// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { LinesHeaderStyles } from "@conklin/App/Components/Cart/LinesHeader";
import CartLinesList, { CartLinesListStyles } from "@conklin/Overrides/Components/CartLinesList";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getDefaultPageSize, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getReviewAndPayCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getQueryStrings } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import {
    getCurrentPromotionsDataView,
    getPromotionsDataView,
} from "@insite/client-framework/Store/Data/Promotions/PromotionsSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => {
    // XNG-Changes
    const { cartId } = getQueryStrings(state);
    const cartState = getReviewAndPayCartState(state);
    const promotionsDataView = cartId ? getPromotionsDataView(state, cartId) : getCurrentPromotionsDataView(state);

    return {
        cartState,
        promotionsDataView,
        defaultPageSize: getDefaultPageSize(state),
        settingsCollection: getSettingsCollection(state),
    };
};

const mapDispatchToProps = {};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface CheckoutReviewAndSubmitProductListStyles {
    centeringWrapper?: InjectableCss;
    orderLinesList?: CartLinesListStyles;
    // XNG-Changes
    linesHeader?: LinesHeaderStyles;
}

export const productListStyles: CheckoutReviewAndSubmitProductListStyles = {
    centeringWrapper: {
        css: css`
            display: flex;
            justify-content: center;
            align-items: center;
            height: 300px;
        `,
    },
};

const styles = productListStyles;

const CheckoutReviewAndSubmitProductList: FC<Props> = ({ cartState, promotionsDataView, settingsCollection }) => {
    const [isCondensed, setIsCondensed] = useState(false);

    if (!cartState.value || !cartState.value.cartLines || !promotionsDataView.value) {
        // XNG-Changes
        return null;
        // return (
        //     <StyledWrapper {...styles.centeringWrapper}>
        //         <LoadingSpinner />
        //     </StyledWrapper>
        // );
    }

    const { productSettings } = settingsCollection;

    return (
        <CartLinesList
            cart={cartState.value}
            promotions={promotionsDataView.value}
            isCondensed={isCondensed}
            onChangeIsCondensed={(event: React.SyntheticEvent<Element, Event>, value: boolean) => setIsCondensed(value)}
            editable={false}
            showSavingsAmount={productSettings.showSavingsAmount}
            showSavingsPercent={productSettings.showSavingsPercent}
            extendedStyles={styles.orderLinesList}
            // XNG-Changes
            hideCondensedSelector={true}
            showAddToList={false}
            includeActions={true}
            linesHeaderStyles={styles.linesHeader}
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(CheckoutReviewAndSubmitProductList),
    definition: {
        displayName: "Product List",
        // XNG-Changes: add "OnePageCheckoutPage"
        allowedContexts: ["CheckoutReviewAndSubmitPage", "OnePageCheckoutPage"],
        group: "Checkout - Review & Submit",
    },
};

export default widgetModule;
